export default {"src":"/_next/static/media/guardMoney.bc902a4f.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};